export default __webpack_public_path__ + "static/media/vijaywadaDeitieFour.382ff200.png";